// extracted by mini-css-extract-plugin
export default {"key-id":"s-YdCv3FQb","keyId":"s-YdCv3FQb","right-tag":"ds1+NB2Xxm","rightTag":"ds1+NB2Xxm","none":"STMFbPI928"};